import { CONDITIONS_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { Button, ButtonLink, ButtonStyles, Dropdown, IconButton, Icons, TextInput } from '@silverfort/sf-components';
import { SCOPE_SHOW_SERVICES } from '../TierConsts';

const NamingConventionList = ({
    conventions,
    selectedConvention,
    selectConvention,
    onNamingConventionChange,
    onConventionDelete,
    onAddConvention,
    onClearAll,
    scope
}) => {
    return (
        <div className="w-full h-full flex flex-col">
            <div className="flex justify-between px-4 h-10 items-center border-b border-sf-gray-100">
                <div className="text-sf font-medium">Naming conventions {`(${conventions.length})`}</div>
                <ButtonLink
                    onClick={onClearAll}
                    underline={true}
                    text={'Clear All'}
                    className="text-xs font-normal text-sf-gray-400"
                />
            </div>
            <div className="py-4 px-2 w-full h-full overflow-y-auto no-scrollbar">
                {conventions.map((convention, index) => (
                    <NamingConventionsRow
                        key={`name_convention_${index}`}
                        nameConvention={convention}
                        selected={index === selectedConvention && SCOPE_SHOW_SERVICES[scope]}
                        onClick={() => selectConvention(index)}
                        onChange={(value) => onNamingConventionChange(value, index)}
                        onDelete={() => onConventionDelete(index)}
                        showProtocols={SCOPE_SHOW_SERVICES[scope]}
                    />
                ))}
                <div className="p-2">
                    <Button
                        onClick={onAddConvention}
                        text={'Add'}
                        icon={Icons.Add}
                        buttonStyle={ButtonStyles.Primary}
                    />
                </div>
            </div>
        </div>
    );
};

const NAME_CONVENTION_TYPES_OPTIONS = Object.values(CONDITIONS_OPTIONS).map((condition) => {
    return { title: condition.label, value: condition.value };
});

const NamingConventionsRow = ({ nameConvention, onChange, onDelete, onClick, selected, showProtocols = true }) => {
    const protocols = nameConvention.protocols ?? [];
    const protocolsText =
        protocols.length === 0 ? '0 protocols' : `${protocols.length} ${protocols.length === 1 ? 'protocol' : 'protocols'}`;

    const changeType = (type) => {
        onChange({ conditionType: type });
    };

    const changeCondition = (condition) => {
        onChange({ conditionString: condition });
    };

    return (
        <div
            onClick={onClick}
            className={`flex justify-between items-center h-12 px-2 gap-2 ${
                showProtocols ? 'w-[350px]' : 'w-full'
            } rounded-lg cursor-pointer ${
                selected ? 'bg-[#F5FAFF] border border-sf-primary-500' : 'hover:bg-sf-light-100'
            }`}>
            <div className={`flex ${showProtocols ? 'w-[216px]' : 'w-[302px]'} items-center gap-2`}>
                <div>
                    <Dropdown
                        className="w-[112px]"
                        selectedItems={nameConvention.conditionType}
                        onChange={changeType}
                        items={NAME_CONVENTION_TYPES_OPTIONS}
                        variant="trigger"
                        size="small"
                    />
                </div>

                <div className="flex-1 w-full">
                    <TextInput
                        className={'w-full h-8'}
                        value={nameConvention.conditionString}
                        onChange={changeCondition}
                    />
                </div>
            </div>
            <div className="flex flex-1 gap-2 items-center justify-between">
                {showProtocols && (
                    <div className="h-6 px-2 flex items-center content-center rounded bg-sf-primary-100 w-fit text-12 font-medium text-[#0D71C5] whitespace-nowrap">
                        {protocolsText}
                    </div>
                )}
                <div className="flex items-center" onClick={(e) => e.stopPropagation()}>
                    <IconButton icon={Icons.Cancel} onClick={onDelete} iconSize={16} />
                </div>
            </div>
        </div>
    );
};

export default NamingConventionList;
